import React , { Component } from 'react'
import {NavLink} from 'react-router-dom'
import LoginAccountInput from '../LoginAccountInput'
import LoginPasswordInput from "../LoginPasswordInput";
import LoginThirdBtn from "../LoginThirdBtn";
import BsyBtn from "../BsyBtn";
import tipAlert from "../BsyAlertTip/Staticize";
import './index.css'
import ImgCodeInput from "../ImgCodeInput";
import i18n from "i18next";


export default class LoginAccountPassword extends Component{
    constructor(props) {
        super(props);
        this.languageCont=React.createRef()
        this.state={
            errMsg:'',
            lang : React.cookie.load("bby_lang") ? React.cookie.load("bby_lang") : window._bby_config.lang,
            languageShow : false,
            errorInput:false,
            hasImgCode:window.data_config.vercode,
            ...props.customLoginConfig
        }
    }

    languageShow = (event) =>{
        event.stopPropagation()
        const {languageShow} = this.state
        this.setState({languageShow:!languageShow})
    }

    languageChange = (event) =>{
        const s=event.target.parentNode.children;
        for(let i = 0; i <s.length; i++){
            s[i].classList.remove("select");
        }
        event.target.classList.add("select");
        const n = event.target.classList[0];
        React.cookie.save("bby_lang",n)
        i18n.changeLanguage(n);
        this.setState({lang:n})
    }

    imgCodeValue = (ref) =>{
        this.imgCode = ref
    }

    componentDidMount() {
        const el = document.getElementsByClassName("loginAccountPassword")[0];
        document.addEventListener('click', this.hideAllMenu);
        el.addEventListener("keyup", (event) =>{
            if(event.keyCode === 13){
                this.accountPasswordLogin()
            }
        })
    }

    hideAllMenu = (event) =>{
        event.stopPropagation()
        const {languageShow} = this.state
        if(languageShow === true){
            this.setState({languageShow:false})
        }
    }

    componentWillUnmount() {
        const el = document.getElementsByClassName("loginAccountPassword")[0]
        el.removeEventListener("keyup",null)
    }

    accountPasswordLogin = () =>{
        const accountValue = this.account.getValue();
        const passwordValue = this.password.getValue();
        this.setState({
            errMsg:'',
            errorInput:false
        })
        const {remberPassword, hasImgCode} = this.state;
        let data
        if(hasImgCode){
            const code = this.imgCode.getValue().value;
            data={
                "account":accountValue.value, // 账号 手机号 邮箱
                "password":passwordValue.value, //密码
                "country_code":accountValue.countryCode, //地区编码
                "rember_password":remberPassword ? 1 : 0,   //是否记住密码 1记住 0不记住
                "code":code  //验证码 三次失败后需要
            }
        }else{
            data={
                "account":accountValue.value, // 账号 手机号 邮箱
                "password":passwordValue.value, //密码
                "country_code":accountValue.countryCode, //地区编码
                "rember_password":remberPassword ? 1 : 0,   //是否记住密码 1记住 0不记住
            }
        }
        React.axios('/user/signin',{
            "mode":"account",
            "data":data
        }).then(res => {
            if(res.data.code===200){
                tipAlert({
                    type: "success",
                    msg : res.data.msg
                })
                window.location.href = res.data.redirectTo
            }else if(res.data.code===206){
                hasImgCode && this.imgCode.changeCode()
                this.setState({
                    hasImgCode:true,
                    errMsg: res.data.msg,
                    errorInput:true
                })
            }else if(res.data.code===205){
                const {changeContCodePage} = this.props
                changeContCodePage('LoginCodeSetPasswordShow')
            }else if(res.data.code===400){
                tipAlert({
                    type: "error",
                    msg : res.data.msg
                })
            }
        }).catch(res => {
            hasImgCode && this.imgCode.changeCode();
            const res1 =  res.response ? res.response.data : res.data;
            this.setState({
                errMsg: res1 && res1.msg,
                errorInput:true
            })
            // tipAlert({
            //     type: "error",
            //     msg : res && res.msg
            // })
        })
    }



    accountValue = (ref) =>{
        this.account = ref
        
    }

    passwordValue = (ref) =>{
        this.password = ref
    }

    render() {
        const {remberPassword, hasImgCode, errMsg, errorInput, lang, remberPasswordShow, siteName, corpLogoImageUrl, corpLogoSwitch} = this.state
        const {rightTitle, changeContModePage, isMirror, isCorp, customLoginConfig} = this.props;
        const modeBtnShow={
            dingdingShow:true,
            workWechatShow:true,
            qyWechatShow:true,
            feishuShow:true,
            qyzjWechatShow:true,
            wechatShow:true,
            LoginAccountPasswordShow: false,
            LoginCodeShow: true,
            ssoShow: true,
        }
        return (
            <div className="loginAccountPassword">
                <div className="loginContentBox">
                    {!isMirror ? <div className="title">{rightTitle}</div> : <div className="logo">
                        {corpLogoSwitch && <>
                            <img src={corpLogoImageUrl} alt=""/>
                            <span>{siteName}</span>
                        </>}
                    </div>}
                    <div className="error-msg">
                        {errMsg}
                    </div>
                    <LoginAccountInput error={errorInput} value={this.account ? this.account.getValue().value : ""} getValue={this.accountValue} />
                    <LoginPasswordInput error={errorInput} getValue={this.passwordValue} />
                    {hasImgCode && <ImgCodeInput error={errorInput} getValue={this.imgCodeValue}/>}
                    <div className="loginAutoRemember" style={{'marginTop':(hasImgCode ? '0.9375rem' : '0')}}>
                        <div className="autoCheck">
                            {remberPasswordShow && <>
                                <i className={remberPassword ? "icon-bsy-iconxuanzhong" : "icon-bsy-check2"} onClick={()=>{
                                    this.setState({remberPassword:!remberPassword})
                                }} />
                                <input id="autoCheck" type="checkbox" onChange={(event)=>{
                                    this.setState({remberPassword:event.target.checked})
                                }} defaultChecked={remberPassword}/>
                                <label style={{color: remberPassword ? "#333333" : ""}} htmlFor="autoCheck">{React.language('Remember.login')}</label>
                            </>}
                        </div>
                        {!isMirror && <NavLink className="rememberBtn" to={window.rootDirectroy + "/user/getpwd"}>
                            <span>{React.language('forgot.login')}</span>
                        </NavLink>}
                    </div>

                    <BsyBtn style={{'margin-bottom':(hasImgCode ? '0.625rem' : '1.875rem'),'margin-top':hasImgCode ? '0.75rem' : '1.4375rem'}} onClick={this.accountPasswordLogin} text={window.screen.width > 1200 ? React.language('signin') : isMirror ? React.language('login.mirror.signin') : React.language('signin')} />
                </div>
                
                <LoginThirdBtn customLoginConfig={customLoginConfig} isCorp={isCorp} modeBtnShow={modeBtnShow} changeContModePage={changeContModePage} />
            </div>
        );
    }
}


